import { render, staticRenderFns } from "./LostPhoneAccess.vue?vue&type=template&id=2b36dbaa"
import script from "./LostPhoneAccess.vue?vue&type=script&lang=js"
export * from "./LostPhoneAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports